import * as React from "react";
const SvgLightBulb = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "light-bulb", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 60,
  strokeLinecap: "round"
}, d: "M 351.366 368.019 C 349.29 292.156 416.579 227.082 480.826 225.141" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 60,
  strokeLinecap: "round"
}, d: "M 640.35 770.497 C 640.35 783.167 630.08 793.438 617.41 793.438 L 406.6 793.438 C 393.93 793.438 383.66 783.167 383.66 770.497 L 383.66 664.843 C 383.66 602.972 248.46 547.236 248.46 388.724 C 248.46 243.173 366.45 125.181 512 125.181 C 657.55 125.181 775.54 243.173 775.54 388.724 C 775.54 562.746 640.35 600.675 640.35 664.838 L 640.35 770.497 Z" }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 60,
  strokeLinecap: "round"
}, x1: 438.695, y1: 898.82, x2: 585.305, y2: 897.79 }));
export default SvgLightBulb;
